import { render, staticRenderFns } from "./bancos_clientes_screen.vue?vue&type=template&id=3e71d3bd&scoped=true"
import script from "./bancos_clientes_screen.vue?vue&type=script&lang=js"
export * from "./bancos_clientes_screen.vue?vue&type=script&lang=js"
import style0 from "./bancos_clientes_screen.vue?vue&type=style&index=0&id=3e71d3bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71d3bd",
  null
  
)

export default component.exports